import { __assign, __rest } from "tslib";
import React from 'react';
import { Box, Button as ButtonElement, Popover as PopoverElement, } from '@marvelapp/ui';
import CopyToClipboard from '../CopyToClipboard';
import LinkElement from '../Link';
export default function OptionsButton(_a) {
    var canDelete = _a.canDelete, isPopoverActive = _a.isPopoverActive, onDelete = _a.onDelete, onTogglePopover = _a.onTogglePopover, playTarget = _a.playTarget, playUrl = _a.playUrl;
    return (React.createElement(Box, null,
        React.createElement(Button, { "data-testid": "options-button", isActive: isPopoverActive, onClick: onTogglePopover }, "Options"),
        React.createElement(Popover, { isActive: isPopoverActive },
            playUrl && (React.createElement(React.Fragment, null,
                React.createElement(Link, { target: playTarget, to: playUrl }, "Play"),
                React.createElement(CopyToClipboard, { as: Link, btnText: "Copy link", display: "block", fontSize: 2, margin: 2, text: playUrl, whiteSpace: "nowrap" }))),
            canDelete && (React.createElement(Link, { hoverColor: "red", onClick: onDelete }, "Delete")))));
}
function Button(_a) {
    var children = _a.children, isActive = _a.isActive, props = __rest(_a, ["children", "isActive"]);
    return (React.createElement(ButtonElement, __assign({ bg: isActive ? 'marvel' : 'white', color: isActive ? 'white' : 'slate', fontSize: 2, hoverBg: isActive ? 'marvelDark' : 'white', kind: isActive ? undefined : 'ghost', px: "12px" }, props), "Options"));
}
function Popover(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(PopoverElement, __assign({ align: "right", padding: 2, paddingRight: 3, position: "bottom", showOn: "custom" }, props), children));
}
function Link(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(LinkElement, __assign({ display: "block", fontSize: 2, margin: 2, whiteSpace: "nowrap" }, props), children));
}
